module.exports = __webpack_public_path__ + "img/43.9955052b.png";